module.exports = __webpack_public_path__ + "static/img/u172.de9f232.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u172.jpg
// module id = QcLd
// module chunks = 0